import Axios from 'axios'
import Cookies from 'js-cookie'
import store from '@/state/store'

const axiosQuoteApi = Axios.create({
  baseURL: process.env.VUE_APP_QUOTE_API_URL + 'api',
})

axiosQuoteApi.interceptors.request.use(
  function (config) {
    const trackingParams = Cookies.getJSON('tracking') || {}
    try {
      if (window.ga) {
        const ga = window.ga.getAll()

        if (ga.length > 0) {
          trackingParams.gaClientId = ga[0].get('clientId')
        }
      }
    } catch (e) {} /* eslint-disable-line no-empty */

    if (Cookies.get('hubspotutk')) trackingParams.hubspot = Cookies.get('hubspotutk')

    if (Cookies.get('isTestMode')) trackingParams.isTestMode = Cookies.get('isTestMode')

    if (store.getters.getReferrer) trackingParams.referrer = store.getters.getReferrer

    if (document.referrer) trackingParams.launcherUrl = document.referrer

    if (window.FS && window.FS.getCurrentSessionURL) trackingParams.fullstoryUrl = window.FS.getCurrentSessionURL()

    if (!config.data) config.data = {}

    if (Object.keys(trackingParams).length > 0) config.data.trackingParams = trackingParams

    if (store.getters['user/token']) config.headers.common.Authorization = 'Bearer ' + store.getters['user/token']

    if (store.getters.getCustomerPortalToken) config.headers.common.Authorization = 'Bearer ' + store.getters.getCustomerPortalToken

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  },
)

export default axiosQuoteApi
